import React from "react";
import IframeResizer from "iframe-resizer-react";
import HtmlContent from "../../../../../shared/html_content";

export default function SupportPopup({onModalClose}) {
  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            Support
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <HtmlContent identifier={"exhibition.info"}/>
        </div>
      </div>
    </div>
  </div>
}